import { FC, useContext, useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography, useMediaQuery } from "@material-ui/core";
import LockStakingInput from "../LockTokens/LockStakingInput";
import LockActionCard from "../LockTokens/LockActionCard";
import { useWeb3 } from "../../services/web3/hooks/useWeb3";
import { formatDecimalNumber } from "../../utils/web3/formatBalance";
import { Subscription } from "../../interfaces";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { MdClose } from "react-icons/md";
import ProjectModalStyles from "../Styles/ProjectModalStyles";
import theme from "../../helpers/theme";

const LockGainsModal: FC<any> = ({ open, toggleModal }) => {

    const styles = ProjectModalStyles()
    const isActive = useMediaQuery(theme.breakpoints.down("sm"));
    const { gainsBalance: totalGains } = useWeb3();
    const { createSubscription } = useContext<any>(SubscriptionContext);

    const [gainsBalance, setGainsBalance] = useState<number>(0);
    const [totalTokens, setTokens] = useState<number>(0);
    const [duration, setStakeDuration] = useState<number>(3);

    const inputRef = useRef<any>(null);

    useEffect(() => {
        if (totalGains && totalGains.formatted) {
          let formattedBalance = formatDecimalNumber(totalGains.formatted)
          setGainsBalance(Number(formattedBalance))
        }
    }, [totalGains]);
    
    return (
                <Dialog
                    open={open}
                    disableEscapeKeyDown={false}
                    fullWidth
                    className={styles.gainsmodal}
                >
                    {
                        !isActive && (
                            <DialogTitle>
                                <Grid 
                                    container 
                                    justifyContent="flex-end"
                                    style={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Grid item style={{position:'absolute', top:5, right:5}}>
                                        <IconButton
                                            edge="end"
                                            color="inherit"
                                            aria-label="close"
                                            style={{marginRight:0}}
                                            onClick={(event) => toggleModal(false)}
                                        >
                                            <MdClose />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </DialogTitle>
                        )
                    }
                    <DialogContent>
                        <Grid
                            direction="row"
                            container
                            style={{
                                padding:0,
                                maxWidth: '100%',
                                overflow: 'hidden',
                            }}
                            lg={12}
                            > 
                                <LockStakingInput
                                    gainsBalance={gainsBalance}
                                    inputRef={inputRef}
                                    createSubscription={createSubscription}
                                    showStakeModalInfo={false}
                                    toggleModal={toggleModal}
                                    totalTokens={totalTokens}
                                    setTotalTokens={setTokens}
                                    duration={duration}
                                    setDuration={setStakeDuration}
                                />
                                <LockActionCard
                                    gainsBalance={gainsBalance}
                                    createSubscription={createSubscription}
                                    totalTokens={totalTokens}
                                    duration={duration}
                                />
                        </Grid>
                    </DialogContent>
                </Dialog>
    )
}

export default LockGainsModal;